export default "/images/4e02124dac2696455f2449191e649fc1.avif";